import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useState } from "react";

import { useTranslation } from "contexts/TranslationContext";
import { serviceName } from "./otherServicesData";
import vendorPlaceholder from "assets/svg/vendorPlaceholder.png";

// Reusable service card (image → uppercase title → "Apply Now →").
// Shared by both the Home carousel and the "View All" list page. The whole card
// is the click target; `onClick` receives the item. Sits inside a width-
// controlling parent (fixed-width in the carousel, grid cell on the list page),
// so the card itself is always full-width.
const OtherServiceCard = ({ item, onClick }) => {
  const { translate, language } = useTranslation();
  const isArabic = language?.code === "ar";
  const isRtl = language?.dir === "rtl";
  const name = serviceName(item, isArabic);
  // Fall back once if the image is broken. Kept in state rather than mutating
  // img.src, so the fallback survives re-renders and a placeholder that also
  // fails can't retrigger onError forever.
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <div className="cursor-pointer group" onClick={() => onClick?.(item)}>
      <div className="w-full h-44 md:h-60 rounded-xl overflow-hidden bg-[#F6F6F6]">
        <img
          src={!item?.image || imageFailed ? vendorPlaceholder : item.image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          onError={() => setImageFailed(true)}
        />
      </div>

      <h3 className="mt-4 text-[#1F1F1F] text-sm md:text-base font-semibold uppercase tracking-wide">
        {name}
      </h3>

      <span className="mt-1 inline-flex items-center gap-1 text-primary text-xs md:text-sm font-medium">
        {translate("OTHER_SERVICES.APPLY_NOW")}
        {isRtl ? <ArrowLeftOutlined className="text-black" /> : <ArrowRightOutlined className="text-black" />}
      </span>
    </div>
  );
};

export default OtherServiceCard;
